export class BiMap<T, K> {
  map: Map<T, K>;
  reverseMap: Map<K, T>;
  constructor(map: Map<T, K>) {
    this.map = map
    this.reverseMap = new Map<K, T>()
    map.forEach((value, key) => {
      this.reverseMap.set(value, key)
    })
  }

  get(key: T | K): T | K {
    return this.map.get(key as T) ?? this.reverseMap.get(key as K)
  }
  getForward(key: T): K {
    return this.map.get(key)
  }

  getReverse(key: K): T {
    return this.reverseMap.get(key)
  }
}
